<template>
    <div class="post-index">
        <!-- header -->
        <Header />
        <!-- end header -->

        <!-- main content -->
        <header class="pt-5 border-bottom bg-light">
            <div class="container pt-md-1 pb-md-1">
                <h1 class="bd-title mt-4 font-weight-bold"><img src="@/assets/kontak.png" style="width:40px;"> DEVELOPER</h1>
                <p class="bd-lead">Informasi Developer</p>
            </div>
        </header>

        <!-- breadcrumb -->
        <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }" class="text-decoration-none"><img src="@/assets/home2.png"  style="width:20px; padding-bottom:4px;"> Home</router-link></li>
            <li class="breadcrumb-item"><router-link :to="{ name: 'contact' }" class="text-decoration-none"><img src="@/assets/kontak.png"  style="width:20px; padding-bottom:4px;"> Developer</router-link></li>
        </ol>
        </nav>
        <!-- end breadcrumb -->

        <div class="container-fluid mt-5 mb-5">

            <div class="row">
                <div class="col-md-7">
                    <div class="card border-2 shadow-sm rounded">
                        <div class="card-body">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.387170103481!2d99.62764721437793!3d2.9898971978225037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30324bf6a2ea5631%3A0x790ed7bea0dc2eb2!2sJl.%20Elang%2C%20Lestari%2C%20Kec.%20Kisaran%20Tim.%2C%20Kabupaten%20Asahan%2C%20Sumatera%20Utara!5e0!3m2!1sen!2sid!4v1603105115963!5m2!1sen!2sid" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card border-2 shadow-sm rounded">
                        <div class="card-body">
                            <h3>Developer</h3>
                            <hr>
                            <p>
                                <img src="@/assets/topi.png"  style="width:20px; padding-bottom:4px;"> Siswa Dicoding <br />
                                https://www.dicoding.com/users/rachel_gultom <br/>
                                 <img src="@/assets/linkedin.png"  style="width:20px; padding-bottom:4px;"> Profile Linkedin <br />
                                 https://www.linkedin.com/in/rachel-gultom-66133b197
                                <br />
                                 <img src="@/assets/instagram.png"  style="width:20px; padding-bottom:4px;"> https://www.instagram.com/rachelgultom01/
                                <br />
                                 <img src="@/assets/facebook.png"  style="width:20px; padding-bottom:4px;"> 
                                <ShareNetwork
                                network="facebook"
                                url="https://halotoba.netlify.app/"
                                title="HALO Toba - Danau Toba for Us"
                                description="Website pariwisata yang dikhususkan untuk destinasi Danau Toba"
                                quote="Website Mini untuk Danau Toba"
                                hashtags="halotoba">
                                Bagikan Website ini
                            </ShareNetwork>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- main content -->

        <!-- footer -->
        <Footer />
        <!-- end footer -->
    </div>
</template>

<script>
    //import component
    import Header from "@/components/Header"
    import Footer from "@/components/Footer"


    export default {
        name: 'ContactIndex',
        components: {
            Header,
            Footer
        }
    }
</script>